export enum ViewMode {
    View = 1,
    Add = 2,
    Edit = 3,
    FullAccess = 4
}
